var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "335px",
    height: "337px",
    viewBox: "0 0 335 337",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.598901,80 C211.617152,80 241.626373,110.009222 241.626373,147.027472 C241.626373,165.13905 234.442883,181.572833 222.769624,193.635101 L263.152046,234.016295 C266.949317,237.813566 266.949317,243.97016 263.152046,247.767431 C259.354775,251.564702 253.198182,251.564702 249.400911,247.767431 L249.400911,247.767431 L207.913887,206.280407 C207.684651,206.051171 207.469253,205.813336 207.267694,205.567941 C197.602961,210.973681 186.460765,214.054945 174.598901,214.054945 C137.58065,214.054945 107.571429,184.045723 107.571429,147.027472 C107.571429,110.009222 137.58065,80 174.598901,80 Z M174.598901,101.16657 C149.270624,101.16657 128.737999,121.699195 128.737999,147.027472 C128.737999,172.355749 149.270624,192.888374 174.598901,192.888374 C199.927178,192.888374 220.459803,172.355749 220.459803,147.027472 C220.459803,121.699195 199.927178,101.16657 174.598901,101.16657 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.3%",
    y: "-12.3%",
    width: "126.5%",
    height: "124.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.615111451 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Errors/unique/404",
    transform: "translate(-553.000000, -154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(553.000000, 154.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("text", {
    id: 4,
    fontFamily: "GEInspira-Bold, GE Inspira",
    fontSize: 220,
    fontWeight: "bold",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 206
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "4-copy",
    fontFamily: "GEInspira-Bold, GE Inspira",
    fontSize: 220,
    fontWeight: "bold",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 218,
    y: 206
  }, "4")), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    fillRule: "nonzero",
    transform: "translate(186.785714, 165.307692) rotate(-8.000000) translate(-186.785714, -165.307692) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#47ADC1",
    xlinkHref: "#path-1"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Page-not-found.",
    fontFamily: "GEInspira, GE Inspira",
    fontSize: 35,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2,
    y: 259
  }, "Page not found.")), /*#__PURE__*/React.createElement("text", {
    id: "Use-the-main-navigat",
    fontFamily: "Helvetica",
    fontSize: 15,
    fontWeight: "normal",
    "line-spacing": 20,
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 302
  }, "Use the main navigation at the top of the page to "), /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 322
  }, "browse the major areas of this application.")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.049e93d5e3452b98bbd4b47824867ae7.svg";
export { ForwardRef as ReactComponent };